import { jwtDecode } from "jwt-decode";
import { User } from "../../models/user";
import { Workspace } from "../../models/workspace";

export const transformWorkspace = (workspace: Workspace, users: User[]) => {
  const currentUser: User = jwtDecode(localStorage.getItem("accessToken") ?? "");

  if (workspace.isDefault && workspace.ownerUserId === currentUser?.userId) {
    workspace.isMain = true;
  }

  const authorizedUsers = users.filter((u) => workspace.authorizedUserIds.includes(u.userId));

  return { ...workspace, authorizedUsers };
};
